import DailySalesManageLayout from './DailySalesManageLayout';

export default DailySalesManageLayout;
